import axios from 'axios'

const PAYSLIPS_ENDPOINT = 'https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/get-payslips'
const DOCUMENTS_ENDPOINT = 'https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/get-pay-documents'

async function getPayslips (clientId, userId) {
  if (!clientId || !userId) {
    throw new Error('Missing Client/User id')
  }
  
  var payslips = []
  var payslipRecords = []
  var error = null

  let params = {
    clientId: clientId,
    userId: userId
  }
  
  const [payslipsDataCall, additionalPayslipsDataCall]  = await Promise.all([
    axios.get(`${PAYSLIPS_ENDPOINT}`, { params: params }),
    axios.get(`${PAYSLIPS_ENDPOINT}`, { params: {...params, getLinkedEmployees: true} })
  ])

  if (payslipsDataCall.data.errorMessage && !additionalPayslipsDataCall.data.length) {
    error = payslipsDataCall.data.errorMessage
  } else {
    payslips = (payslipsDataCall.data.errorMessage) ? additionalPayslipsDataCall.data : [...payslipsDataCall.data, ...additionalPayslipsDataCall.data]

    let payslipRecordsCall = await axios.get(`${PAYSLIPS_ENDPOINT}/${userId}`)

    if (payslipRecordsCall.data.errorMessage) {
      error = payslipRecordsCall.data.errorMessage
    } else {
      let timestampPayslips = payslips.filter(p => p.timestamp)
      payslipRecords = payslipRecordsCall.data

      
      
      for (let i = 0; payslipRecords.length > i; i++) {
        // CHECK FOR TIMESTAMP (SAME TAX/DATE PERIOD)
        let createdAtTimestamp = new Date(payslipRecords[i].created_at).getTime() / 1000
        let timestampCheck = timestampPayslips.find(tp => tp.timestamp == createdAtTimestamp)

        if (timestampCheck) {
          payslipRecords[i].payslip_date = timestampCheck.name.split('.')[0]
          payslipRecords[i].payslip_url = timestampCheck.url
          if (payslips.findIndex(payslip => payslip.url == timestampCheck.url) === -1) continue
          payslips.splice(payslips.findIndex(payslip => payslip.url == timestampCheck.url), 1)
          continue
        }

        let dbDate = payslipRecords[i].process_date.substring(0, 10)
        let dbDateParts = dbDate.split('-')
        let dbDateParsed = dbDate

        if (dbDateParts[0].length === 4) {
          dbDateParsed = dbDateParts[2] + '-' + dbDateParts[1] + '-' + dbDateParts[0]
        }
        
         // USE UUID AS FILENAME
         if (payslipRecords[i].useUuid) {
          let target = payslips.find(payslip => payslip.url.includes(payslipRecords[i].id))
          if (target && target.url) {
            payslipRecords[i].payslip_url = target.url
          } else {
            let payslip = payslips.filter(item => {
              let payslipName = item.name.split('.')[0]
              let payslipDate = payslipName.split('-')
              let payslipDateParsed = payslipName
    
              if (payslipDate[0] === 4) {
                payslipDateParsed = payslipDate[2] + '-' + payslipDate[1] + '-' + payslipDate[0]
              }
    
              return payslipDateParsed === dbDateParsed
            })
            payslipRecords[i].payslip_url = payslip[0].url
          }
        } else {
          let payslip = payslips.filter(item => {
            let payslipName = item.name.split('.')[0]
            let payslipDate = payslipName.split('-')
            let payslipDateParsed = payslipName
  
            if (payslipDate[0] === 4) {
              payslipDateParsed = payslipDate[2] + '-' + payslipDate[1] + '-' + payslipDate[0]
            }
  
            return payslipDateParsed === dbDateParsed
          })
          payslipRecords[i].payslip_url = payslip[0].url
        }

        payslipRecords[i].payslip_date = dbDateParsed
      }

      payslipRecords.sort((a, b) => {
        return new Date(b.process_date) - new Date(a.process_date)
      })
    }
  }

  return {
    payslips: payslips,
    records: payslipRecords,
    error: error
  }

}

async function getPayDocuments (clientId, userId, documentType) {
  if (!clientId || !userId) {
    throw new Error('Missing Client/User id')
  }
  
  var documents = []
  var documentRecords = []
  var error = null

  let params = {
    clientId: clientId,
    userId: userId
  }

  if (documentType) {
    params.documentType = documentType
  }

  const [ documentsCall, additionalDocumentsCall] = await Promise.all([
    axios.get(`${DOCUMENTS_ENDPOINT}`, { params: params }),
    axios.get(`${DOCUMENTS_ENDPOINT}`, { params: {...params, getLinkedEmployees: true } })
  ])

  if (documentsCall.data.errorMessage && !additionalDocumentsCall.data.length) {
    error = documentsCall.data.errorMessage
  } else if (!documentsCall.data.length && !additionalDocumentsCall.data.length) {
    error = `There are currently no documents available`
  } else {
    documents = (documentsCall.data.errorMessage) ? additionalDocumentsCall.data : [...documentsCall.data, ...additionalDocumentsCall.data]

    let query = (documentType) ? `${DOCUMENTS_ENDPOINT}/${userId}?documentType=${documentType}` : `${DOCUMENTS_ENDPOINT}/${userId}`

    let recordsCall = await axios.get(query)

    if (recordsCall.data.errorMessage) {
      error = recordsCall.data.errorMessage
    } else {

      documentRecords = recordsCall.data.filter(record => record.document_type !== 6)
      for (let i = 0; documentRecords.length > i; i++) {

        let document = documents.filter(item => {
          let documentType = item.url.slice(133, 134)
          return item.name === `${documentRecords[i].process_period}.pdf` && documentType == documentRecords[i].document_type
        })

        documentRecords[i].document_url = document[0].url
        let date = documentRecords[i].created_at.substring(0, 10).split('-')
        documentRecords[i].created_at = `${date[2]}-${date[1]}-${date[0]}`
      }
      
    }
  }

  return {
    documents: documents,
    records: documentRecords,
    error: error
  }

}

export {
  getPayslips,
  getPayDocuments
}